import React from "react";

function ButtonLoader2() {
  return (
    <div>
      <div
        className="guest-web-loader h-2 w-2"
        style={{ width: "30px", height: "30px" }}
      ></div>
    </div>
  );
}

export default ButtonLoader2;
